import { type Locale } from "@skyltmax/locales"
import React from "react"

export interface SignWebLocaleContextType {
  signWebLocale: Locale
  setSignWebLocale: (locale: Locale) => void
}

export const SignWebLocaleContext = React.createContext<SignWebLocaleContextType>({
  signWebLocale: "en-IE",
  setSignWebLocale: () => {},
})

export const useSignWebLocaleContext = () => React.useContext(SignWebLocaleContext)
